<template>
<div class="pageTestDiagram">

</div>

</template>

<script>
  export default {
    name: 'test-diagram'
  }
</script>

<style scoped>

</style>
